import { FC } from 'react';

import { useBreakpoint } from '@contexts/breakpoints';

import { CompanyPromotionGroupProps } from './CompanyPromotionGroupInterface';
import {
  DesktopPromotionsContainer,
  PromotionHiddenButton,
  ResponsivePromotionContainer,
  StyledPromotionGroup,
  StyledPopover,
} from './PromotionGroupStyle';
import CompanyPromotionItem from './CompanyPromotionItem';

const CompanyPromotionGroup: FC<CompanyPromotionGroupProps> = (props) => {
  const { promotions, ...otherProps } = props;

  const screens = useBreakpoint();

  // ============================================
  // prepare the shown and the hidden promotions
  // ============================================
  const showPromotions = promotions.slice(0, 1);
  const hiddenPromotions = promotions.slice(1, promotions.length);

  // ============================================
  // custom function to render the hidden promotions
  // ============================================
  const renderHiddenPromotions = () => {
    return promotions?.map((h, i) => (
      <CompanyPromotionItem
        style={{ marginBottom: '10px' }}
        key={i}
        text={h.text}
        logo={h.logo}
        promotion={h}
      />
    ));
  };

  // ============================================
  // custom function to render the responsive promotions
  // ============================================
  const renderResponsivePromotions = (): React.ReactElement[] => {
    return promotions?.map((h, i) => (
      <CompanyPromotionItem key={i} text={h.text} logo={h.logo} />
    ));
  };

  return (
    <StyledPromotionGroup {...otherProps}>
      {screens && screens.xl === false ? (
        <ResponsivePromotionContainer data-testid='responsive-promotion'>
          {renderResponsivePromotions()}
        </ResponsivePromotionContainer>
      ) : (
        <DesktopPromotionsContainer data-testid='desktop-promotion'>
          {showPromotions?.map((h, i) => (
            <CompanyPromotionItem key={i} text={h.text} logo={h.logo} />
          ))}

          {hiddenPromotions.length === 0 ? null : (
            <StyledPopover
              styles={{
                body: {
                  height: '143px',
                  overflow: 'scroll',
                  marginBottom: '1px',
                  padding: '6px 8px 0 8px',
                  borderRadius: '2px',
                  border: 'solid 1px #dedede',
                },
              }}
              placement='top'
              color='#fff'
              content={() => renderHiddenPromotions()}
              trigger='click'
            >
              <PromotionHiddenButton data-testid='desktop-promotion-hidden'>
                +{hiddenPromotions.length}
              </PromotionHiddenButton>
            </StyledPopover>
          )}
        </DesktopPromotionsContainer>
      )}
    </StyledPromotionGroup>
  );
};

export default CompanyPromotionGroup;
